import { action, observable } from 'mobx';
import { BaseStore } from '~web/store/base/base-store';

export class UserProfileFlowStore extends BaseStore {
  @observable addPhotoOverlayShown: boolean;
  @observable accountClosed: boolean;

  constructor() {
    super();
    this.clear();
  }

  @action
  showAddPhotoOverlay(): void {
    this.addPhotoOverlayShown = true;
  }

  @action
  hideAddPhotoOverlay(): void {
    this.addPhotoOverlayShown = false;
  }

  @action
  setAccountClosed(closed: boolean): void {
    this.accountClosed = closed;
  }

  clear(): void {
    this.addPhotoOverlayShown = false;
    this.accountClosed = false;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/store/user-profile/user-profile-flow-store.ts